<script setup>
import BLayoutPanel from "@/dokos-ui/components/layout/BLayoutPanel.vue";
import { _navContentsComponent } from "@/dokos-ui/composables/provideNavContents";
import { _topbarContentsComponent } from "@/dokos-ui/composables/provideTopBarContents";
import { useBSidebarToggle } from "@/dokos-ui/composables/useBSidebarToggle";
const { asRef: showSidebar } = useBSidebarToggle();
</script>

<template>
  <div class="BLayout fixed inset-0 overflow-hidden md:bg-gray-50">
    <header class="BLayout__top">
      <nav class="flex gap-1 p-2 items-center border-b bg-white">
        <component :is="_topbarContentsComponent" />
      </nav>
    </header>

    <BLayoutPanel class="BLayout__side flex flex-col p-2 overflow-auto" :class="showSidebar && 'BLayout__side--visible'">
      <nav class="grow flex flex-col gap-2">
        <component :is="_navContentsComponent" />
      </nav>
    </BLayoutPanel>

    <BLayoutPanel class="BLayout__main md:p-2 overflow-auto !pb-[30vh]">
      <slot />
    </BLayoutPanel>
  </div>
</template>

<style>
.BLayout {
  display: grid;
  grid-template-areas: "top top" "side main";
  grid-template-columns: clamp(180px, 25vw, 250px) 1fr;
  grid-template-rows: 50px 1fr;
}
.BLayout__top {
  grid-area: top;
}
.BLayout__side {
  grid-area: side;
}
.BLayout__main {
  grid-area: main;
  scrollbar-gutter: stable;
}

@media (max-width: 768px) {
  :root {
    --BSidebarToggle--display: block;
  }
  .BLayout__side {
    grid-column: 1 / -1;
    z-index: 2;
    @apply bg-white transition;
  }
  .BLayout__side:not(.BLayout__side--visible) {
    transform: translateX(-100vw);
  }
  .BLayout__main {
    grid-column: 1 / -1;
  }
}
</style>
